// extracted by mini-css-extract-plugin
module.exports = {"root":"RelatedListings_root__3VvXj","section":"RelatedListings_section__1Fy4q","sectionTitle":"RelatedListings_sectionTitle__cFMiN"};